import { Image } from '../Image/Image';
import { Title } from '../Title/Title';
import styles from './UpsaleBenefits.module.scss';
export const UpsaleBenefits = ({content})=>{
  if(!content){
    return;
  }
  const {image,title,items} = content;
  
  return ( 
    <div className={styles.wrapper}>
      {image && <Image className={styles.image} src={image}/>}
      {title && <Title dangerouslySetInnerHTML={{ __html:title }} tag="h2" className={styles.title}/>}
      {items &&
      items.map((box, index) => {
        const {count, title:boxTitle, text} = box;
        return (
          <div className={styles.box} key={index}>
            {count && <div className={styles.count}>{count}</div>}
            <div className={styles.boxWrapper}>
              {boxTitle && <div className={styles.boxTitle}>{boxTitle}</div>}
              {text && <div className={styles.text}>{text}</div>}
            </div>
          </div>
        )
      })
      }
    </div>
  )
}